
'use client'
import ContactForm from "@/app/programas/components/contactForm";
import StudyPlan from "@/app/programas/components/studyPlan";
import ProgramCharacteristics from "@/app/programas/components/programCharacteristics";
import FooterPrograms from "@/app/programas/components/footerPrograms";
import GeneralDetails from "@/app/programas/components/generalDetails";
import Hero from "@/app/programas/components/hero";
import Header from "@/components/header";
import { useParams } from "next/navigation";
import GeneralLearn from "../components/generalLearn";
import StudyPlanDescription from "../components/studyPlanDescription";

export default function Basico() {
  const params = useParams();
  const { tecnico } = params;
  return (
    <>
      <Header sectionName={tecnico.toString()} />
      <main>
        <div className="xl:pt-44">
          <Hero programName={tecnico.toString()} />
        </div>
        <GeneralDetails programName={tecnico.toString()} />
        <GeneralLearn programName={tecnico.toString()} />
        <StudyPlanDescription programName={tecnico.toString()} />
        <div className="relative mt-50px lg:-mt-[50px]">
          <ContactForm programName={tecnico.toString()} />
          <ProgramCharacteristics programName={tecnico.toString()} />
          <StudyPlan programName={tecnico.toString()} />
        </div>
      </main>
      <FooterPrograms programName={tecnico.toString()} />
    </>
  );
}